<template>
    <el-card class="box-card">
        <div class="component-content">
            <section class="content">
                <div style="margin: 20px 0;">
                    <component-query :queryMode="playerQueryMode" @usersData="getUsersData"></component-query>
                </div>

                <el-table :data="playerData" border style="width: 50%;margin-bottom: 20px;"
                          @current-change="handlePlayerDataChange" highlight-current-row>
                  <el-table-column prop="id" label="用户id"  width="120"></el-table-column>
                  <el-table-column prop="server" label="游戏服编号" width="120"></el-table-column>
                  <el-table-column prop="email" label="sid" width="120"></el-table-column>
                  <el-table-column prop="channel" label="渠道" width="120"></el-table-column>
                  <el-table-column prop="nick" label="昵称"></el-table-column>
                  <el-table-column prop="level" label="等级"></el-table-column>
                  <el-table-column label="禁言状态">
                    <template slot-scope="scope">
                      <span v-if="scope.row.silence == 0">正常</span>
                      <span v-if="scope.row.silence == 1">禁言</span>
                      <span v-if="scope.row.silence == 2">伪禁言</span>
                    </template>
                  </el-table-column>
                  <el-table-column label="封号状态">
                    <template slot-scope="scope">
                      <span v-if="scope.row.block == 0">正常</span>
                      <span v-if="scope.row.block == 1">后台封禁</span>
                      <span v-if="scope.row.block == 2">系统封禁</span>
                    </template>
                  </el-table-column>
                </el-table>

                <div class="query-panel">
                    <el-form :inline="true">
                        <el-form-item label='邮件类型'>
                            <el-select v-model="mailFindBO.mailType" placeholder="请选择" @change="mailTypeChange">
                                <el-option
                                    v-for="item in mailTypeOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="关联id">
                            <el-input v-model="mailFindBO.refId" placeholder="请输入唯一序号" v-if="mailFindBO.mailType == 5 ||
                            mailFindBO.mailType == 6||mailFindBO.mailType == 7 ||mailFindBO.mailType == 8|| mailFindBO.mailType == 10">

                            </el-input>
                            <el-select v-model="mailFindBO.refId" placeholder="请选择" v-else>
                                <el-option
                                    v-if="mailFindBO.mailType == 1"
                                    v-for="item in systemTaskData"
                                    :key="item.id"
                                    :label="item.id + '(' + $t(item.title) + ')'"
                                    :value="item.id">
                                </el-option>
                                <el-option
                                    v-if="mailFindBO.mailType == 2"
                                    v-for="item in systemMailData"
                                    :key="item.id"
                                    :label="item.unique_id + '(' +  JSON.parse(item.content)['title']['zh-Hans'] + ')'"
                                    :value="item.unique_id">
                                </el-option>
                                <el-option
                                    v-if="mailFindBO.mailType == 3"
                                    v-for="item in normalMailData"
                                    :key="item.id"
                                    :label="item.id + '(' +  JSON.parse(item.contentJson)['zh-Hans']['title'] + ')'"
                                    :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label='发送时间区间'>
                            <el-date-picker v-model="dateTime" type="datetimerange" range-separator='至'
                                            start-placeholder='开始时间' end-placeholder='结束时间'
                                            format="yyyy-MM-dd HH:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button size="small" type="primary" @click="findPlayerMail()">查询</el-button>
                        </el-form-item>
                    </el-form>
                </div>

                <el-table :data="dataHandled" border style="margin-top:20px;width: 100%">
                    <el-table-column type="expand">
                        <template slot-scope="props">
                            <el-form label-position="left" inline class="demo-table-expand " label-suffix=":">
                                <el-card>
                                    <div slot="header" class="clearfix">
                                        <span>基础内容</span>
                                    </div>
                                    <template v-if="mailFindBO.mailType == 1 && item.id == props.row.refId" v-for="item in systemTaskData">
                                        <el-form-item label="标题">
                                            {{$t(item.title)}}
                                        </el-form-item>
                                        <el-form-item label="内容">
                                            {{$t(item.content)}}
                                        </el-form-item>
                                        <el-form-item label="发件人">
                                            {{$t(item.sender)}}
                                        </el-form-item>
                                    </template>
                                    <template v-if="mailFindBO.mailType == 2 && item.unique_id == props.row.refId" v-for="item in systemMailData">
                                        <el-form-item label="标题">
                                            <span v-for="(value,key) in JSON.parse(item.content)" v-if="key == 'title'">
                                                <span>{{value['zh-Hans']}}</span>
                                            </span>
                                        </el-form-item>
                                        <el-form-item label="内容">
                                            <span v-for="(value,key) in JSON.parse(item.content)" v-if="key == 'content'">
                                                <span>{{value['zh-Hans']}}</span>
                                            </span>
                                        </el-form-item>
                                        <el-form-item label="发件人">
                                            <span v-for="(value,key) in JSON.parse(item.content)" v-if="key == 'sender'">
                                                <span>{{value['zh-Hans']}}</span>
                                            </span>
                                        </el-form-item>
                                    </template>
                                    <template v-if="mailFindBO.mailType == 3 && item.id == props.row.refId" v-for="item in normalMailData">
                                        <el-form-item label="标题">
                                            <span v-for="(value,key) in JSON.parse(item.contentJson)" v-if="key == 'zh-Hans'">
                                                <span>{{value['title']}}</span>
                                            </span>
                                        </el-form-item>
                                        <el-form-item label="内容">
                                            <span v-for="(value,key) in JSON.parse(item.contentJson)" v-if="key == 'zh-Hans'">
                                                <span>{{value['content']}}</span>
                                            </span>
                                        </el-form-item>
                                        <el-form-item label="发件人">
                                            <span v-for="(value,key) in JSON.parse(item.contentJson)" v-if="key == 'zh-Hans'">
                                                <span>{{value['sender']}}</span>
                                            </span>
                                        </el-form-item>
                                    </template>
                                </el-card>
                            </el-form>
                        </template>
                    </el-table-column>
                    <el-table-column prop="refId" label='关联Id' width="130px" v-if="mailFindBO.mailType == 1">
                    </el-table-column>
                    <el-table-column prop="id" label='邮件id' width="130px">
                    </el-table-column>
                    <el-table-column prop="userId" label='收件人(玩家id)' width="130px">
                    </el-table-column>
                    <el-table-column prop="gmtDisabled" label='失效时间' width="150px" :formatter="formatterTimeDisabled">
                    </el-table-column>
                    <el-table-column prop="gmtCreate" label='发送时间' width="150px" :formatter="formatterTimeCreate">
                    </el-table-column>
                    <el-table-column label='阅读状态-领取状态' width="180px">
                        <template  slot-scope="props">
                            {{props.row.hadRead == true?'已读':'未读'}}
                            -{{props.row.claimed == true?'已领':'未领'}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="rewards" label="奖励"></el-table-column>
                    <el-table-column label='操作'>
                        <template slot-scope="scope">
                            <el-button type="warning" size="mini" @click="delPlayerMailShow(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="pagination">
                    <el-pagination @current-change="handleCurrentChange" :current-page="currentPage"
                                   :page-size="pageSize"
                                   layout="total, prev, pager, next, jumper" :total="totalRow">
                    </el-pagination>
                </div>

                <el-dialog title="删除邮件" :visible.sync="delPlayerMailDialog" width="50%" lock-scroll center>
                    <el-form label-suffix=":" label-width="100px">
                        <el-form-item label="内部操作原因">
                            <el-autocomplete
                                class="inline-input"
                                type="textarea"
                                :maxlength="300"
                                show-word-limit
                                :autosize="{ minRows: 2}"
                                v-model="mailDelBO.reason"
                                :fetch-suggestions="querySearchReasonTemplate"
                                placeholder="请输入内容"
                                @select="handleSelectReason"
                            >
                                <template slot-scope="{ item }">
                                    <span class="addr">{{item.reason}}</span>
                                </template>
                            </el-autocomplete>
                        </el-form-item>
                    </el-form>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="delPlayerMailDialog = false">取消</el-button>
                        <el-button type="primary" @click="delPlayerMail">确认</el-button>
                    </div>
                </el-dialog>
            </section>
        </div>
    </el-card>
</template>

<script>
import paginationController from '../../mixins/pagination'
import actionConfirm from '../../mixins/action_confirm'
import confApi from '../../service/conf_api'
import mailNormalApi from "../../service/mail_api";
import gameApi from '../../service/game_api'
import configSettingApi from '../../service/config_setting_api'
import {
    mapState
} from 'vuex';
import componentServer from '../../components/component_server'
import componentQuery from '../../components/component_query'
import Utils from '../../lib/utils'

export default {
    name: "logs",
    data() {
        return {
            Utils: Utils,
            title: this.$route.meta.title,
            playerQueryMode: ['mode_long_id', 'mode_short_id', 'mode_nick', 'mode_email'],
            mailTypeOptions: [
                {
                    value: 1,
                    label: '系统任务'
                },
                {
                    value: 2,
                    label: '全局邮件'
                },
                {
                    value: 3,
                    label: '普通邮件'
                },
                {
                    value: 5,
                    label: '批量邮件'
                },
              {
                value: 6,
                label: '酋长邮件'
              },
              {
                value: 7,
                label: '兑换码邮件'
              },
              {
                value: 8,
                label: '活动邮件'
              },
              {
                value: 10,
                label: 'APPT邮件'
              }

            ],
            systemTaskData: [],
            systemMailData: [],
            normalMailData: [],

            dateTime: '',

            playerData: [],

            mailFindBO: {
                uri: '',
                uid: '',
                mailType: 1,
                refId: '',
                content: '',
                stime: 0,
                etime: 0
            },


            optionMap:{
                '0':this.$t("reward_editor.39"),
                '1':this.$t("reward_editor.40"),
                '2':this.$t("reward_editor.41"),
                '3':this.$t("reward_editor.42"),
                '4':this.$t("reward_editor.43"),
                '5':'约束性道具',
                '6':this.$t("reward_editor.44"),
                '7':'战纹',
                '8':this.$t("reward_editor.46"),
                '9':this.$t("reward_editor.47"),
                '10':'回复类道具',
                '11':'头像',
                '12':'头像框',
                '13':'宝箱',
                '14':'皮肤',
                '15':'时效类道具',
                '16':'部落头像',
                '17':'起源盘',
                '18':'自选元核',
                '19':'进化光谱',
                '20':'聊天框',
                '21':'战斗框',
                '22':'元核碎片',
                '23':'元核髓',
            },
            optionValue: '0',
            count1: '',
            count2: '',
            countSwitch: false,
            rate: 0.1,
            value: '',
            emblemEntryConfigs: [],
            emblemLevel: 1,
            emblemStage: 0,
            emblemQuality: 1,
            emblemFate:0,
            emblemFateCustomizeTags:[],
            emblemFateCustomize:100,
            emblemMainProperty: 1,
            emblemFateProperty: 51,
            editEmblemEntries:[
                {
                    entry:[3, 0],
                    quality:0,
                    active:true
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
                {
                    entry:[3, 0],
                    quality:0,
                    active:false
                },
            ],

            rewardsCN: '',
            rewardsCNId: '',

            mailDelBO: {
                uri: '',
                uid: '',
                sid: '',
                id: '',
                reason: ''
            },

            delPlayerMailDialog: false,

            // 模板数据
            reasonTemplateData: [],
        }
    },
    mixins: [paginationController, actionConfirm],
    computed: {
        ...mapState({
            token: state => state.user.userInfo.loginToken,
        }),
    },
    mounted() {
        this.getAllReadData();
        this.getReasonListAll();
    },
    methods: {
        getUsersData(val) {
            this.playerData = val;
        },

        getAllReadData() {
            confApi.getReadData({
                token: this.token,
                tableName: 'system_task_config'
            }).then(res => {
                this.systemTaskData = res;
            })

            confApi.getReadData({
                token: this.token,
                tableName: 'system_mail_config'
            }).then(res => {
                this.systemMailData = res;
            })

            mailNormalApi.findAllNormalMails({
                token: this.token
            }).then(res => {
                this.normalMailData = res;
            })
        },

        handlePlayerDataChange(currentRow) {
            this.mailFindBO.uri = currentRow.uri;
            this.mailFindBO.uid = currentRow.id;

            this.mailDelBO.uri = currentRow.uri;
            this.mailDelBO.uid = currentRow.id;
            this.mailDelBO.sid = currentRow.server;
        },

        // 玩家邮件查询
        findPlayerMail() {
            if ('' !== this.dateTime) {
                this.mailFindBO.stime = this.dateTime[0].getTime();
                this.mailFindBO.etime = this.dateTime[1].getTime();
            }
            gameApi.findMails({
                token: this.token,
                mailFindBO: this.mailFindBO
            }).then(res => {
                // this.dataHandled = res.content.mails;
                res.content.mails.forEach(item => {
                    item.rewards = item.rewards + (item.rewards?'(':'') + this.rewardsToCN(item.rewards) + (item.rewards?')':'');
                })
                this.rawData = res.content.mails;
                this.totalRow = res.content.mails.length;
            })
        },

        rewardsToCN(rewards,id) {
            var arr = rewards.split(',');
            var result = '';
            arr.forEach(item => {
                if (item !== '') {
                    this.resolveRewardStr(item);

                    let optionValueCN = this.optionMap[this.optionValue];
                    let idCn = this.getIdCn(this.optionValue,this.value);
                    let finalCount = '';
                    if (this.countSwitch) {
                        finalCount = this.count1 + "-" + this.count2;
                    } else {
                        finalCount = this.count1
                    }
                    let finalContentCN = optionValueCN + "$" + idCn + "_" + finalCount;
                    result = result + (result?',':'') + finalContentCN;
                }

            })

            this.rewardsCN = result;
            this.rewardsCNId = id;
            return result;
        },

        resolveRewardStr(str){
            let self = this;

            if (str == '') {
                self.countSwitch = false;
                self.rateSwitch = false;
                self.isDetail = false;
                self.count1 = 1;
                self.count2 = 1;
                self.rate = 0.1;
                self.emblemLevel = 1;
                self.emblemStage = 0;
                self.emblemQuality = 1;
                self.emblemMainProperty = 1;
                self.emblemFate = 0;
                self.emblemFateCustomize = 100;
                self.emblemFateProperty = 51;

                self.editEmblemEntries = [
                    {
                        entry:[3, 0],
                        quality:0,
                        active:true
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                    {
                        entry:[3, 0],
                        quality:0,
                        active:false
                    },
                ]
            }

            let rewardArray = str.toString().split("_");

            for (let index = 0; index < rewardArray.length; index++) {
                const element = rewardArray[index];
                switch (index) {
                    case 0:
                        let bigTypeArry = element.split("$");
                        //大类
                        self.optionValue = bigTypeArry[0];
                        //identify
                        self.value = parseInt(bigTypeArry[1]);
                        if (self.value == 50001) {
                            self.emblemRandomByQuality = false;
                        } else {
                            self.emblemRandomByQuality = true;
                        }
                        break;
                    case 1:
                        //数量
                        let countArry = element.split("-");
                        if(countArry.length>1){
                            self.countSwitch = true;
                            self.count1 = countArry[0];
                            let rateAndCount = countArry[1].split('|');
                            if (rateAndCount.length>1) {
                                self.rateSwitch = true;
                                self.count2 = rateAndCount[0];
                                self.rate = rateAndCount[1];
                            } else {
                                self.rateSwitch = false;
                                self.count2 = countArry[1];
                            }
                        }else{
                            self.countSwitch = false;

                            let rateAndCount = countArry[0].split('|');
                            if (rateAndCount.length>1) {
                                self.rateSwitch = true;
                                self.count1 = rateAndCount[0];
                                self.rate = rateAndCount[1];
                            } else {
                                self.rateSwitch = false;
                                self.count1 = countArry[0];
                            }
                        }
                        break;
                    case 2:
                        //等级
                        self.emblemLevel = parseInt(element);

                        if (self.optionValue == '7') {
                            self.warGrooveQuality = parseInt(element);
                        }
                        break;
                    case 3:
                        //阶段
                        self.emblemStage = parseInt(element);

                        if (self.optionValue == '7') {
                            if (element) {
                                self.warGrooveChannelSwitch = true;
                                self.warGrooveChannelUp = parseInt(element);
                            } else {
                                self.warGrooveChannelSwitch = false;
                            }
                        }
                        break;
                    case 4:
                        //品质
                        self.emblemQuality = parseInt(element);

                        if (self.optionValue == '7') {
                            self.warGrooveChannelDown = parseInt(element);
                        }
                        break;
                    case 5:
                        //宿命
                        let fateArray = element.split("#");
                        self.emblemFate = 3;
                        if(fateArray.length>1){
                            for (let i = 0; i < fateArray.length; i++) {
                                const element = fateArray[i];
                                let item = fateArray.splice("@");
                                self.emblemFateCustomizeTags[i] = {id:parseInt(item[0]),chance:parseInt(item[1])}
                            }
                        }else{
                            if(element>0){
                                self.emblemFate = 2;
                                self.emblemFateProperty = parseInt(element);
                            }else{
                                self.emblemFate = 0;
                            }
                        }

                        if (self.optionValue == '7') {
                            self.warGrooveChannelLeft = parseInt(element);
                        }

                        break;
                    case 6:
                        //宿命自定义概率
                        self.emblemFateCustomize = parseInt(element*100);

                        if (self.optionValue == '7') {
                            self.warGrooveChannelRight = parseInt(element);
                        }
                        break;
                    case 7:
                        //主属性
                        self.emblemMainProperty = parseInt(element);
                        break;
                    case 8:
                        //词条属性
                        let entryArray = element.split("#");
                        for (let index = 0; index < entryArray.length; index++) {
                            const entryItem = entryArray[index];
                            let current = self.editEmblemEntries[index];

                            self.emblemEntryConfigs.forEach(item => {
                                item.children.forEach(iitem => {
                                    if (iitem.value == entryArray[index].split('@')[0]&&entryArray[index].split('@').length>1) {
                                        self.editEmblemEntries[index].entry = [item.value,iitem.value];
                                        self.editEmblemEntries[index].active = true;
                                    } else {
                                        self.editEmblemEntries[index].active = false;
                                    }
                                })
                            })

                            self.editEmblemEntries[index].quality = parseInt(entryArray[index].split('@')[1]);
                        }

                        let countAndEntry = entryArray[entryArray.length-1].split('|');
                        if (countAndEntry.length>1) {
                            self.rateSwitch = true;
                            self.rate = countAndEntry[1];
                        } else {
                            self.rateSwitch = false;
                        }
                        break;
                    default:
                        break;
                }
            }
        },

        getIdCn(optionValue,id){
            let self = this;
            if(optionValue == "0" || optionValue == "3" || optionValue == "4" || optionValue == "5" || optionValue == "9" ||
                optionValue == "10" || optionValue == "11" || optionValue == "12" || optionValue == "13" || optionValue == "14" || optionValue == "15" ||
                optionValue == "20" || optionValue == "21" || optionValue == "22" ){
                //道具
                return self.$t('propConfigName_'+id);
            }else if(optionValue == "1"){
                //怪兽
                return self.$t('monsterName_' + id);
            }else if(optionValue == "2"){
                //怪兽碎片
                return self.$t('monsterName_' + ((id>>0)-10000)) + "碎片";
            }else if(optionValue == "6"){
                //怪兽觉醒水晶
                return self.$t('monsterName_' + ((id>>0)-20000)) + "觉醒结晶";
            }else if(optionValue == "8"){
                //怪兽觉醒水晶碎片
                return self.$t('monsterName_' + ((id>>0)-30000)) + "觉醒结晶碎片";
            }else if(optionValue == "7"){
                //战纹
                return self.$t('warGrooveConfigName_' + id);
            }else if(optionValue == "19"){
                //怪兽觉醒水晶碎片
                return self.$t('monsterName_' + ((id>>0)-70000)) + "的进化光谱";
            }
        },

        formatterTimeDisabled(row) {
            var gmtDisabled = row.gmtDisabled;
            gmtDisabled = Utils.formatDate(gmtDisabled);
            return gmtDisabled;
        },

        formatterTimeCreate(row) {
            var gmtCreate = row.gmtCreate;
            gmtCreate = Utils.formatDate(gmtCreate);
            return gmtCreate;
        },

        delPlayerMailShow(data) {
            this.delPlayerMailDialog = true;
            var mailDelBO = this.mailDelBO;
            mailDelBO.id = data.id;
            mailDelBO.reason = '';
        },

        // 玩家邮件删除
        delPlayerMail() {
            gameApi.delMail({
                token: this.token,
                mailDelBO: this.mailDelBO
            }).then(res => {
                this.delPlayerMailDialog = false;
                this.findPlayerMail();
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                })
            })
        },

        // 模板列表查询
        getReasonListAll() {
            configSettingApi.reasonList({
                token: this.token
            }).then(res => {
                this.reasonTemplateData = res;
            })
        },

        querySearchReasonTemplate(queryString, cb) {
            var data = this.reasonTemplateData;
            var results = queryString ? data.filter(this.createFilter(queryString)) : data;
            // 调用 callback 返回建议列表的数据
            cb(results);
        },

        createFilter(queryString) {
            return (data) => {
                return (data.reason.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
            };
        },
        handleSelectReason(item) {
            this.mailDelBO.reason = item.reason;
        },

        mailTypeChange() {
            this.mailFindBO.refId = '';
        }
    },
    components: {
        componentServer,
        componentQuery
    }
}
</script>

<style scoped lang="less">
    .demo-table-expand label {
        color: #99a9bf;
    }
    .reward-text {
        color: #5daf34;
    }
    .inline-input {
        width: 400px;
    }
</style>



// WEBPACK FOOTER //
// src/views/players/query_player_mails.vue